interface EmptyStateProps {
  title: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
  icon?: string;
}

export default function EmptyState({
  title,
  description,
  actionLabel,
  onAction,
  icon = "ri-search-eye-line",
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-background-300 bg-background-100/60 px-6 py-16 text-center">
      <span className="flex h-16 w-16 items-center justify-center rounded-full bg-accent-100 text-accent-700">
        <i className={`${icon} text-3xl`} />
      </span>
      <h3 className="mt-4 font-heading text-lg font-bold text-foreground-900">{title}</h3>
      {description && <p className="mt-2 max-w-md text-sm text-foreground-500">{description}</p>}
      {actionLabel && onAction && (
        <button
          type="button"
          onClick={onAction}
          className="mt-5 inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-accent-500 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-accent-600"
        >
          <i className="ri-refresh-line text-base" />
          {actionLabel}
        </button>
      )}
    </div>
  );
}